var map = {
	"./dankort.svg": [
		95283,
		5283
	],
	"./klarna.svg": [
		79775,
		9775
	],
	"./maestro.svg": [
		40850,
		850
	],
	"./mastercard.svg": [
		59210,
		9210
	],
	"./mobilepay.svg": [
		67109,
		7109
	],
	"./paypal.svg": [
		63564,
		3564
	],
	"./sofort.svg": [
		2381,
		2381
	],
	"./swish.svg": [
		75145,
		5145
	],
	"./trustly.svg": [
		32198,
		2198
	],
	"./vipps.svg": [
		95405,
		5405
	],
	"./visa.svg": [
		63443,
		3443
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 52991;
module.exports = webpackAsyncContext;